import * as dto from 'client/dto';
import axios from 'client';

const axiosInstance = axios;

function getAirportInformation(locationId: number): Promise<dto.GetAirportModel> {
  return axiosInstance.get(`/api/airport/${locationId}`).then(({ data }) => data);
}

export default {
  getAirportInformation,
};
